import AxiosMockAdapter from 'axios-mock-adapter';
import axios, { V1Axios } from './server';

const instance = new AxiosMockAdapter(axios, { delayResponse: 0 });

export default instance;
